import type { NextPage } from 'next'

import { security } from 'data/seo'
import Security from 'views/security-fraud'

const SecurityPage: NextPage = () => <Security />

export default SecurityPage

export async function getStaticProps() {
  return {
    props: { SEO: security }
  }
}
